import * as React from 'react'

function SvgBellFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 3.5a1.5 1.5 0 00-3 0v.624C9.243 4.84 6 8.541 6 13v6H3.5a1.5 1.5 0 000 3h23a1.5 1.5 0 000-3H24v-6c0-4.46-3.243-8.161-7.5-8.876V3.5zM19 24a4 4 0 01-8 0h8z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgBellFilled
